import { classNames } from '@dimjs/utils';
import { NativeProps, withNativeProps } from '../../utils/native-props';
import './style.less';

const classPrefix = 'v-check-icon';

/**
 * ----check-checked-bg-color 默认值: --v-color-primary
 * --check-disabled-bg-color 默认值: #ebedf0
 */
export type CheckIconVarStyle =
  | '--check-size'
  | '--check-bg-color'
  | '--check-checked-bg-color'
  | '--check-disabled-bg-color'
  | '--check-border-color'
  | '--check-border-radius'
  | '--check-checked-bg-image';

export type CheckIconProps = {
  checked?: boolean;
  disabled?: boolean;
  onClick?: (e) => void;
} & NativeProps<CheckIconVarStyle>;

export const CheckIcon = (props: CheckIconProps) => {
  const checked = props.checked;
  const disabled = props.disabled;
  const className = classNames(classPrefix, {
    [`${classPrefix}-checked`]: checked,
    [`${classPrefix}-checked-disabled`]: checked && disabled,
    [`${classPrefix}-disabled`]: !checked && disabled,
  });
  return withNativeProps(props, <div className={className} onClick={props.onClick}></div>);
};
